module.exports = __webpack_public_path__ + "media/images/icons/filled/instagram-a99cedb508c131c093576e70e25d32d5.svg";